import { SortingState } from "@tanstack/react-table";
import { useState } from "react";

export function useManualPagination(props: { pageSize: number, page: number, onPaginationChange?: ( pagination: { pageIndex: number, pageSize: number }) => void }) { 
  const [currentPage, setCurrentPage] = useState<number>(props.page);
  const [pageSize, setPageSize] = useState<number>(props.pageSize);
  const [totalRows, setTotalRows] = useState<number>(0);
  
  const pageCount = totalRows > 0 ? Math.ceil(totalRows / pageSize) : 0;
    
  return {
    currentPage, setCurrentPage,
    setPageSize,
    setTotalRows,
    manualPagination: {
      pageIndex: Math.max(0, currentPage - 1),
      pageSize,
      totalRows,
      pageCount,
      onPaginationChange: ( pagination: { pageIndex: number, pageSize: number }) => { 
        setCurrentPage(pagination.pageIndex + 1);
        setPageSize(pagination.pageSize);
        props.onPaginationChange?.(pagination);
      }      
    }
  };
}

export function useManualSorting(props: { initialSorting: SortingState, onSortingChange?: (newSort: SortingState) => void }) { 
  const [sorting, setSorting] = useState<SortingState>(props.initialSorting);
  return {
    sorting,
    onSortingChange: (updaterOrValue: SortingState | ((old: SortingState) => SortingState)) => {
      const newSort = typeof updaterOrValue === 'function' ? updaterOrValue(sorting) : updaterOrValue;
      setSorting(newSort);
      props.onSortingChange?.(newSort);
    }
  }
}
